export const specialties = [
    "accessibility",
    "adventure",
    "architecture",
    "art",
    "cultural",
    "family_friendly",
    "food_and_wine",
    "history",
    "music",
    "nature",
    "nightlife",
    "photography",
    "shopping",
    "sports"
];
